import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-custom-gradient dark:bg-gray-950 text-gray-50 p-4">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold">
            {t('pages.not_found.oops_page_not_found')}
          </h1>
          <p className="text-gray-200">
            {t('pages.not_found.the_requested_page_doesnt_exist')}
          </p>
        </div>
        <Link
          to="/"
          className="inline-flex h-10 items-center justify-center rounded-md bg-gray-50 px-6 text-sm font-medium text-gray-950 shadow transition-colors hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50 dark:bg-gray-800 dark:text-gray-50 dark:hover:bg-gray-700 dark:focus-visible:ring-gray-300"
          preload={false}
        >
          {t('pages.not_found.go_back_to_home')}
        </Link>
      </div>
    </div>
  );
}
